{
  "familyId": "SWW-VT-ZIJN-HEBBEN",
  "questions": [
    {
      "id": "SWW-VT-ZIJN-HEBBEN-001",
      "familyId": "SWW-VT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct? 'Gisteren ... ik ziek.'",
      "options": ["was", "ben", "is", "waren"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Zijn in de verleden tijd", "content": "Zijn → was (enkelvoud: ik/hij/zij/het) of waren (meervoud: wij/jullie/zij).\n\nIk was, jij was, hij was\nWij waren, jullie waren, zij waren", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "zijn", "forms": { "stam": "ben", "tt_ik": "ben", "tt_jij": "bent", "tt_hij": "is", "vt_ik": "was", "vt_wij": "waren", "vd": "geweest" }, "label": "Zijn: was (enkelvoud) / waren (meervoud)" } }
      ],
      "conceptId": "vt_zijn_was_enkelvoud",
      "pedagogy": { "dok": 2 },
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Gisteren' geeft aan dat het verleden tijd is. 'Ik' is enkelvoud. Zijn → was (enkelvoud). Dus: 'Gisteren was ik ziek.'",
        "solutionSteps": ["Signaalwoord: 'gisteren' → verleden tijd", "Onderwerp: 'ik' → enkelvoud", "Zijn → was (enkelvoud VT)"],
        "distractorExplanations": {
          "0": "Goed! 'Was' is de verleden tijd enkelvoud van 'zijn'.",
          "1": "'Ben' is tegenwoordige tijd. 'Gisteren' vraagt om verleden tijd → was.",
          "2": "'Is' is tegenwoordige tijd derde persoon. Bij 'ik' en verleden tijd → was.",
          "3": "'Waren' is meervoud. Bij 'ik' (enkelvoud) gebruik je 'was'."
        }
      }
    },
    {
      "id": "SWW-VT-ZIJN-HEBBEN-002",
      "familyId": "SWW-VT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct? 'De kinderen ... gisteren in het park.'",
      "options": ["waren", "was", "zijn", "is"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Was of waren?", "content": "Enkelvoud → was (ik was, hij was)\nMeervoud → waren (wij waren, de kinderen waren)\n\nTip: 'de kinderen' = zij (meervoud) → waren", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "zijn", "forms": { "stam": "ben", "tt_ik": "ben", "tt_jij": "bent", "tt_hij": "is", "vt_ik": "was", "vt_wij": "waren", "vd": "geweest" }, "label": "Zijn: meervoud = waren" } }
      ],
      "conceptId": "vt_zijn_waren_meervoud",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'De kinderen' is meervoud (= zij). Verleden tijd meervoud van 'zijn' = waren. Dus: 'De kinderen waren gisteren in het park.'",
        "solutionSteps": ["Onderwerp: 'de kinderen' → meervoud (= zij)", "Verleden tijd (gisteren)", "Zijn → waren (meervoud VT)"],
        "distractorExplanations": {
          "0": "Goed! 'De kinderen' is meervoud → waren.",
          "1": "'Was' is enkelvoud. 'De kinderen' is meervoud → waren.",
          "2": "'Zijn' is tegenwoordige tijd. 'Gisteren' vraagt om verleden tijd → waren.",
          "3": "'Is' is tegenwoordige tijd enkelvoud. Hier heb je verleden tijd meervoud nodig → waren."
        }
      }
    },
    {
      "id": "SWW-VT-ZIJN-HEBBEN-003",
      "familyId": "SWW-VT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct? 'Vorige week ... hij een nieuwe fiets.'",
      "options": ["had", "heeft", "hebben", "hadden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hebben in de verleden tijd", "content": "Hebben → had (enkelvoud: ik/hij/zij/het) of hadden (meervoud: wij/jullie/zij).\n\nIk had, jij had, hij had\nWij hadden, jullie hadden, zij hadden", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "hebben", "forms": { "stam": "heb", "tt_ik": "heb", "tt_jij": "hebt", "tt_hij": "heeft", "vt_ik": "had", "vt_wij": "hadden", "vd": "gehad" }, "label": "Hebben: had (enkelvoud) / hadden (meervoud)" } }
      ],
      "conceptId": "vt_hebben_had_enkelvoud",
      "variantIndex": 3,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "'Vorige week' geeft verleden tijd aan. 'Hij' is enkelvoud. Hebben → had (enkelvoud VT). Dus: 'Vorige week had hij een nieuwe fiets.'",
        "solutionSteps": ["Signaalwoord: 'vorige week' → verleden tijd", "Onderwerp: 'hij' → enkelvoud", "Hebben → had (enkelvoud VT)"],
        "distractorExplanations": {
          "0": "Goed! 'Had' is de verleden tijd enkelvoud van 'hebben'.",
          "1": "'Heeft' is tegenwoordige tijd. 'Vorige week' vraagt om verleden tijd → had.",
          "2": "'Hebben' is tegenwoordige tijd meervoud. Bij 'hij' en verleden tijd → had.",
          "3": "'Hadden' is meervoud. Bij 'hij' (enkelvoud) gebruik je 'had'."
        }
      }
    },
    {
      "id": "SWW-VT-ZIJN-HEBBEN-004",
      "familyId": "SWW-VT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct? 'Wij ... vorig jaar op vakantie in Frankrijk.'",
      "options": ["waren", "was", "zijn", "bent"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Was of waren?", "content": "Wij = meervoud → waren\nIk/hij/zij/het = enkelvoud → was\n\nTip: als je 'wij' kunt invullen, gebruik je 'waren'.", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "zijn", "forms": { "stam": "ben", "tt_ik": "ben", "tt_jij": "bent", "tt_hij": "is", "vt_ik": "was", "vt_wij": "waren", "vd": "geweest" }, "label": "Zijn: 'wij' is meervoud → waren" } }
      ],
      "conceptId": "vt_zijn_waren_wij",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Wij' is meervoud. 'Vorig jaar' geeft verleden tijd aan. Zijn → waren (meervoud VT). Dus: 'Wij waren vorig jaar op vakantie in Frankrijk.'",
        "solutionSteps": ["Onderwerp: 'wij' → meervoud", "Signaalwoord: 'vorig jaar' → verleden tijd", "Zijn → waren (meervoud VT)"],
        "distractorExplanations": {
          "0": "Goed! 'Wij' is meervoud → waren.",
          "1": "'Was' is enkelvoud. Bij 'wij' (meervoud) gebruik je 'waren'.",
          "2": "'Zijn' is tegenwoordige tijd. 'Vorig jaar' vraagt om verleden tijd → waren.",
          "3": "'Bent' is tegenwoordige tijd bij 'jij'. Bij 'wij' en verleden tijd → waren."
        }
      }
    },
    {
      "id": "SWW-VT-ZIJN-HEBBEN-005",
      "familyId": "SWW-VT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_zijn_hebben",
      "questionType": "fill_in",
      "question": "Vul de verleden tijd in: 'Zij (hebben) ... gisteren huiswerk.' Typ het juiste woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["hadden"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hebben → had/hadden", "content": "Zij (meervoud) + verleden tijd = hadden.\nEnkelvoud → had, meervoud → hadden.", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "hebben", "forms": { "stam": "heb", "tt_ik": "heb", "tt_jij": "hebt", "tt_hij": "heeft", "vt_ik": "had", "vt_wij": "hadden", "vd": "gehad" }, "label": "Hebben: meervoud = hadden" } }
      ],
      "conceptId": "vt_hebben_hadden_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Zij' is hier meervoud. Hebben → hadden (meervoud VT). Dus: 'Zij hadden gisteren huiswerk.'",
        "solutionSteps": ["Onderwerp: 'zij' → meervoud", "Verleden tijd van 'hebben' meervoud = hadden"]
      }
    },
    {
      "id": "SWW-VT-ZIJN-HEBBEN-006",
      "familyId": "SWW-VT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_zijn_hebben",
      "questionType": "fill_in",
      "question": "Vul in: Wij ... (hebben) gisteren een proefwerk. Gebruik de verleden tijd.",
      "correctAnswer": "hadden",
      "data": {
        "acceptedAnswers": ["hadden"],
        "placeholder": "verleden tijd van hebben",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hebben in de verleden tijd", "content": "Hebben → had (enkelvoud: ik/hij/zij) of hadden (meervoud: wij/jullie/zij). 'Wij' is meervoud → hadden.", "icon": "lightbulb" } },
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "hebben", "forms": { "stam": "heb", "tt_ik": "heb", "tt_jij": "hebt", "tt_hij": "heeft", "vt_ik": "had", "vt_wij": "hadden", "vd": "gehad" }, "label": "Hebben: 'wij' is meervoud → hadden" } }
      ],
      "conceptId": "vt_hebben_hadden_fill_in",
      "variantIndex": 6,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "'Gisteren' = verleden tijd. 'Wij' = meervoud. Hebben → had (enkelvoud) / hadden (meervoud). Wij hadden.",
        "solutionSteps": [
          "Signaalwoord: 'gisteren' → verleden tijd",
          "Onderwerp: 'wij' → meervoud",
          "Hebben → hadden (meervoud VT)"
        ]
      }
    },
    {
      "id": "SWW-VT-ZIJN-HEBBEN-007",
      "familyId": "SWW-VT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 6,
      "skill": "verleden_tijd",
      "subSkill": "vt_zijn_hebben",
      "questionType": "matching",
      "question": "Koppel elk onderwerp aan de juiste verleden tijd van 'zijn'.",
      "correctAnswer": null,
      "data": {
        "pairs": [
          { "left": "Ik", "right": "was" },
          { "left": "Wij", "right": "waren" },
          { "left": "Hij", "right": "was" },
          { "left": "Jullie", "right": "waren" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "verbTable", "showWhen": "wrong", "data": { "verb": "zijn", "forms": { "stam": "ben", "tt_ik": "ben", "tt_jij": "bent", "tt_hij": "is", "vt_ik": "was", "vt_wij": "waren", "vd": "geweest" } } }
      ],
      "conceptId": "vt_zijn_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Zijn in de verleden tijd: enkelvoud (ik, hij, zij, het, jij) → was. Meervoud (wij, jullie, zij) → waren. Ik was, hij was, wij waren, jullie waren.",
        "solutionSteps": [
          "Enkelvoud (ik, jij, hij/zij/het) → was",
          "Meervoud (wij, jullie, zij) → waren"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}